export function getFiles() {    
    let url = `${process.env.REACT_APP_API_URL}/api/files`;
    return fetch(url)
}

export default { getFiles }